import * as React from "react";
import CompassNameIcon from "../images/general/CgiNameIconBlack.svg";
import CompassLogoGradient from "../images/general/CompassIconGradient.svg";
import { Box, Icon, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NotOptimized({}) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: { xs: "flex", md: "none" },
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mb: 1,
          mt: 8,
          mx: 2,
        }}
      >
        <Icon sx={{ width: "auto", height: "auto" }}>
          <img draggable={false} src={CompassLogoGradient} width="70px" />
        </Icon>
        <Icon sx={{ width: "auto", height: "auto", ml: 2 }}>
          <img draggable={false} src={CompassNameIcon} height="60px" />
        </Icon>
      </Box>

      <Typography align="center" sx={{ userSelect: "none" }}>
        {t("notOptimizedForSmallDevices")}
      </Typography>
    </Box>
  );
}
